<ng-container *transloco="let translate">
    <div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
        <div class="dialogHeading">
            <span class="dialogHeadingIcon material-symbols-outlined" aria-hidden="true">tune</span>
            <div class="dialogHeadingText">
                <h4 class="matDialogTitle" mat-dialog-title [textContent]="translate('My Preferences')"></h4>
                <span class="dialogSubtitle" [textContent]="translate('Personalise how enComply works for you. These choices apply only to your account.')"></span>
            </div>
        </div>
        <span class="material-icons mb-1 closeIcon" (click)="attemptClose()" [title]="translate('Close')">close</span>
    </div>
    <mat-dialog-content class="mat-typography matDialogBody userPreferencesDialogBody">
        <nav class="preferencesRail" [attr.aria-label]="translate('Preference categories')">
            <button *ngFor="let section of sections; let i = index" type="button" class="railItem" [class.active]="activeSectionId === section.id" (click)="selectSection(section.id)" [style.animation-delay]="60 + i * 60 + 'ms'" [title]="translate(section.name)">
                <span class="railIconWrap">
                    <span class="material-symbols-outlined railIcon">{{ section.icon }}</span>
                </span>
                <span class="railText">
                    <span class="railName" [textContent]="translate(section.name)"></span>
                    <span class="railDescription" [textContent]="translate(section.description)"></span>
                </span>
                <span class="material-symbols-outlined railChevron" aria-hidden="true">chevron_right</span>
            </button>
        </nav>
        <main class="preferencesContent" [ngSwitch]="activeSectionId">
            <app-landing-page-preference *ngSwitchCase="'landing-page'" (dirtyChange)="onDirtyChange($event)"></app-landing-page-preference>
        </main>
    </mat-dialog-content>
    <div class="closeConfirmOverlay" *ngIf="showCloseConfirm" role="alertdialog" [attr.aria-label]="translate('You have unsaved changes')">
        <div class="closeConfirmCard">
            <span class="closeConfirmIconWrap">
                <span class="material-symbols-outlined closeConfirmIcon" aria-hidden="true">warning</span>
            </span>
            <span class="closeConfirmTitle" [textContent]="translate('You have unsaved changes')"></span>
            <span class="closeConfirmMessage" [textContent]="translate('Your changes will be lost if you close now.')"></span>
            <span class="closeConfirmActions">
                <button type="button" class="discardCloseButton" (click)="discardAndClose()" [textContent]="translate('Discard and close')"></button>
                <material-button [color]="'primary'" [text]="translate('Keep editing')" (buttonClicked)="keepEditing()"></material-button>
            </span>
        </div>
    </div>
</ng-container>
